import {types, flow} from 'mobx-state-tree';
import * as api from '../../services/api';

// tslint:disable
export const TeamModel = types
  .model('TeamModel', {
    id: types.identifierNumber,
    name: types.string,
    email: types.optional(types.string, ''),
    about: types.maybe(types.string),
    domainName: types.optional(types.string, ''),
    avatar: types.maybe(types.string),
    owner: types.maybe(
      types.model({
        id: types.number,
        firstName: types.string,
        lastName: types.optional(types.string, ''),
        avatar: types.optional(types.string, ''),
        email: types.optional(types.string, '')
      })
    ),
    members: types.map(
      types.model({
        id: types.identifierNumber,
        firstName: types.string,
        lastName: types.optional(types.string, ''),
        avatar: types.optional(types.string, ''),
        email: types.optional(types.string, ''),
        role: types.maybe(
          types.model({
            id: types.identifierNumber,
            name: types.string,
            code: types.string
          })
        )
      })
    ),
    languages: types.map(
      types.model({
        id: types.identifierNumber,
        code: types.string,
        name: types.string
      })
    ),
    serviceType: types.optional(types.string, 'FREE')
  })
  .actions(self => ({
    addMember: (member: any) => {
      self.members.put(member);
    },
    removeMember: (memberId: number) => {
      self.members.delete(String(memberId));
    },
    addNewLanguage: (language: any) => {
      self.languages.set(String(language.id), language);
    },
    removeLanguage: (languageID: number) => {
      self.languages.delete(String(languageID));
    }
  }));

const TeamDetailModel = types
  .model('TeamDetailModel', {
    isLoading: types.optional(types.boolean, false),
    isLoadingAddNewMember: types.optional(types.boolean, false),
    isLoadingAssignMemberManageListings: types.optional(types.boolean, false),
    isOpenChooseListings: types.optional(types.boolean, false),
    isEditingTeamName: types.optional(types.boolean, false),
    isAddOtaAccount: types.optional(types.boolean, false),
    isEditOtaAccount: types.optional(types.boolean, false),
    isAddNewListing: types.optional(types.boolean, false),
    isEditingTeamLanguages: types.optional(types.boolean, false),
    newTeamName: types.maybe(types.string),
    team: types.maybe(TeamModel),

    // New Airbnb Listing Url
    newAirbnbListingId: types.maybe(types.string),
    isAddingAirbnbListingId: types.optional(types.boolean, false),

    // Data add new member
    newUserId: types.maybe(types.number),
    newRoleID: types.maybe(types.number),

    // Data assign member manage listings
    listingIds: types.array(types.number),
    userIds: types.array(types.number),
    roleIdOfListing: types.maybe(types.number),

    // Language Ids
    languageIds: types.array(types.number),
    isUpdateTeamLanguage: types.optional(types.boolean, false)
  })
  .actions(self => ({
    getTeamDetail: flow(function*(teamId: number) {
      self.isLoading = true;
      const response = yield api.getTeam(teamId);
      if (response.status === 200 && response.data) {
        // Convert array to map
        let team = response.data.team;
        team.members = team.members.reduce(
          (results: {[id: string]: any}, r: any) => (
            (results[String(r.id)] = r), results
          ),
          {}
        );

        team.languages = team.languages ? team.languages : [];
        team.languages = team.languages.reduce(
          (results: {[id: string]: any}, r: any) => (
            (results[String(r.id)] = r), results
          ),
          {}
        );

        self.team = team;
        self.isLoading = false;
      }
    }),
    assignUserToTeam: flow(function*(teamId: number) {
      self.isLoadingAddNewMember = true;
      if (!self.newRoleID || !self.newUserId) {
        return;
      }

      const response = yield api.assignUserToTeam(
        teamId,
        self.newUserId,
        self.newRoleID
      );
      if (response.status === 200 && response.data) {
        self.isLoadingAddNewMember = false;
        let user = response.data.member.user;
        let role = response.data.member.role;
        user.role = role;
        if (self.team) {
          self.team.addMember(user);
        }
      }
    }),
    removeUserToTeam: flow(function*(teamId: number, memberId: number) {
      if (self.team) {
        const response = yield api.removeTeamMember(teamId, memberId);
        if (response.status === 200) {
          self.team.removeMember(memberId);
        }
      }
    }),
    bulkAssignMemberToListings: flow(function*(
      teamId: number,
      userIds: Array<number>,
      listingIds: any,
      callback: any
    ) {
      self.isLoadingAssignMemberManageListings = true;

      const membersIds = userIds.map((userId: number, idx: number) => {
        return userId;
      });
      let assigns: any[] = [];

      for (let userIdx in membersIds) {
        let arrReq = listingIds.map((listingId: number, idx: number) => {
          return {userId: membersIds[userIdx], listingId};
        });
        assigns = assigns.concat(arrReq);
      }

      const body = {
        teamId: teamId,
        assigns: assigns
      };

      const response = yield api.bulkAssignListingMembers(body);

      if (response.status < 300 && response.status >= 200) {
        callback(false, 'Assign members manage listings successfully');
      } else {
        callback(true, 'Something went wrong!');
      }
      self.isLoadingAssignMemberManageListings = false;
    }),
    updateTeam: flow(function*(
      teamId: number,
      callback: any,
      avatar: string | undefined
    ) {
      let body = {};
      if (
        (!self.newTeamName ||
          (self.newTeamName && self.newTeamName.trim() === '')) &&
        !avatar
      ) {
        return callback('warning', 'Please change data before update');
      }

      if (self.newTeamName) body['name'] = self.newTeamName;

      if (avatar) body['avatar'] = avatar;

      const response = yield api.updateTeam(teamId, body);
      if (response.status === 200 && response.data) {
        let team = response.data.team;
        team.members = team.members.reduce(
          (results: {[id: string]: any}, r: any) => (
            (results[String(r.id)] = r), results
          ),
          {}
        );
        team.languages = team.languages ? team.languages : [];
        team.languages = team.languages.reduce(
          (results: {[id: string]: any}, r: any) => (
            (results[String(r.id)] = r), results
          ),
          {}
        );
        self.team = team;
        callback('success', 'Update team info success');
      } else {
        callback('error', 'Oops! Something went wrong');
      }
    }),
    updateTeamLanguages: flow(function*(teamId: number, callback: any) {
      if (!self.languageIds || self.languageIds.length === 0) {
        callback('error', 'Please change team languages');
        return;
      }
      self.isUpdateTeamLanguage = true;

      let body = {};
      body['languageIds'] = self.languageIds;
      const response = yield api.updateTeam(teamId, body);
      if (response.status === 200 && response.data) {
        let team = response.data.team;
        team.members = team.members.reduce(
          (results: {[id: string]: any}, r: any) => (
            (results[String(r.id)] = r), results
          ),
          {}
        );
        team.languages = team.languages ? team.languages : [];
        team.languages = team.languages.reduce(
          (results: {[id: string]: any}, r: any) => (
            (results[String(r.id)] = r), results
          ),
          {}
        );
        self.team = team;
        callback('success', 'Update team language successfully!');

        self.languageIds.clear();
      } else {
        callback('error', 'Oops! Something went wrong');
      }

      self.isUpdateTeamLanguage = false;
    }),
    fetAirbnbResources: flow(function*(accountId: number, callback: any) {
      self.isAddingAirbnbListingId = true;
      if (!self.newAirbnbListingId) {
        callback('error', 'Please enter airbnb listing id!');
        self.isAddingAirbnbListingId = false;
        return;
      }

      const listingId = Number(self.newAirbnbListingId);
      if (isNaN(listingId)) {
        callback('error', 'Please enter airbnb listing id!');
        self.isAddingAirbnbListingId = false;
        return;
      }
      const otaListingIds = [`ab_${listingId}`];
      const response = yield api.fetchAirbnbResources(
        accountId,
        otaListingIds
      );
      if (response && response.status === 202) {
        callback('sucess', 'Please refresh page after 3 minutes.');
      }
      self.isAddingAirbnbListingId = false;
    }),
    clearSelectedListings: () => {
      self.listingIds.clear();
    },
    onChangeNewUserId: (userId: number) => {
      self.newUserId = userId;
    },
    onChangeNewRoleId: (roleId: number) => {
      self.newRoleID = roleId;
    },
    onChangeTeamName: (name: string) => {
      self.newTeamName = name;
    },
    toggleChooseListings: () => {
      self.isOpenChooseListings = !self.isOpenChooseListings;
    },
    onToggleEditTeamName: () => {
      self.isEditingTeamName = !self.isEditingTeamName;
    },
    onToggleAddNewOtaAccount: () => {
      self.isAddOtaAccount = !self.isAddOtaAccount;
    },
    onToggleEditOtaAccount: () => {
      self.isEditOtaAccount = !self.isEditOtaAccount;
    },
    onToggleEditingTeamLanguages: () => {
      self.isEditingTeamLanguages = !self.isEditingTeamLanguages;
    },
    onToggleAddNewListing: () => {
      self.isAddNewListing = !self.isAddNewListing;
    },
    addListingSelected: (listingId: number) => {
      self.listingIds.push(listingId);
    },
    selectAllListings: (listingIds: number[]) => {
      self.listingIds.clear();
      self.listingIds.replace(listingIds);
    },
    unselectAllListings: () => {
      self.listingIds.clear();
    },
    removeListingSelected: (listingId: number) => {
      const index = self.listingIds.indexOf(listingId);
      if (index !== -1) {
        self.listingIds.splice(index, 1);
      }
    },
    onChangeRoleIdOfListing: (roleId: number) => {
      self.roleIdOfListing = roleId;
    },
    onChangeUserIds: (userIds: Array<number>) => {
      self.userIds.replace(userIds);
    },
    onChangeNewAirbnbListingUrl: (listingId: string) => {
      self.newAirbnbListingId = listingId;
    },
    onChangeLanguageIds: (languageIds: Array<number>) => {
      self.languageIds.replace(languageIds);
    },
    updateTeamInfo: flow(function*(teamId: number, data: any) {
      self.isLoading = true;
      const response = yield api.updateTeam(teamId, data);
      if (response && response.status === 200 && response.data.team) {
        // Convert array to map
        let team = response.data.team;
        team.members = team.members.reduce(
          (results: {[id: string]: any}, r: any) => (
            (results[String(r.id)] = r), results
          ),
          {}
        );

        team.languages = team.languages ? team.languages : [];
        team.languages = team.languages.reduce(
          (results: {[id: string]: any}, r: any) => (
            (results[String(r.id)] = r), results
          ),
          {}
        );

        self.team = team;
      }
      self.isLoading = false;
    })
  }));

export type TeamDetailModelType = typeof TeamDetailModel.Type;
export default TeamDetailModel;



// WEBPACK FOOTER //
// ./src/models/TeamDetailModel/TeamDetailModel.ts